import type { JSX } from 'react'

import { Tooltip } from '@ui/components/Tooltip/Tooltip'
import { AlertIcon } from '@ui/icons/Alert.icon'

interface TableHeaderTooltipProps<T extends Record<string, string>> {
  headerIds: Partial<T>
  targetHeaderId: keyof T
}

export const TableHeaderTooltip = <T extends Record<string, string>>({
  headerIds,
  targetHeaderId,
}: TableHeaderTooltipProps<T>): JSX.Element => {
  const content = headerIds[targetHeaderId]

  if (content) {
    return (
      <Tooltip content={content}>
        <AlertIcon color='text-low-em' size={14} />
      </Tooltip>
    )
  }

  return <></>
}
